import { invoiceControlStatusConfig } from 'entities';

import { WaitingInfo } from './WaitingInfo';
import { AmountTaken } from './AmountTaken';
import { ProjectValue } from './ProjectValue';

import { StatusInfoComponent, StatusDetailsProps } from './types';

const statusToComponent: Record<string, StatusInfoComponent> = {
  [invoiceControlStatusConfig.waitingInvoiceInfo.code]: WaitingInfo,

  [invoiceControlStatusConfig.readyToInvoice.code]: AmountTaken,

  [invoiceControlStatusConfig.partiallyInvoiced.code]: AmountTaken,

  [invoiceControlStatusConfig.invoiced.code]: AmountTaken,

  [invoiceControlStatusConfig.unassigned.code]: ProjectValue,

  [invoiceControlStatusConfig.pendingApproval.code]: ProjectValue,

  [invoiceControlStatusConfig.paid.code]: ProjectValue,

  [invoiceControlStatusConfig.canceled.code]: ProjectValue,
};

export function StatusDetails({ control }: StatusDetailsProps): JSX.Element {
  const Custom = statusToComponent[control.status];

  return <Custom control={control} />;
}
